import { render, staticRenderFns } from "./BuilderPreview.vue?vue&type=template&id=70ea2e1e"
import script from "./BuilderPreview.vue?vue&type=script&lang=js"
export * from "./BuilderPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports